export class DeploymentTypeMetadata {
  name: string;
  friendlyName: string;
  description: string;
  systemType?: SystemType;
  enableByDefault: boolean;
  featureFlag?: string;
  deploymentLevelRequiredParameters: UserInputPropertySource[];
  deploymentLevelOptionalParameters: UserInputPropertySource[];
  requiredParameters: UserInputPropertySource[];
  optionalParameters: UserInputPropertySource[];
  optionalFeatures: DeploymentTypeMetadata[];
  deploymentFeatures: DeploymentTypeMetadata[];
}

export class UserInputPropertySource {
  name: string;
  friendlyName: string;
  userInputType: InputType;
  description: string;
  secret: boolean;
  defaultValue: any;
  required: boolean;
  options: string[];
  referencedByFeatures: string[];
  clientSideValidators: ClientSideValidator[];
  /** When set to "dynamic", options must be fetched from an API endpoint instead of using the static `options` array. */
  optionsSource?: 'dynamic' | null;
  /** Names of sibling controls whose values are required before dynamic options can be loaded. */
  dependsOn?: string[];
  /** Relative URL to call to fetch dynamic options. */
  optionsEndpoint?: string;
}

/** A single option returned by the dynamic property-options API. */
export interface DynamicOption {
  label: string;
  value: string;
}

export enum InputType {
  TextField = "TextField",
  PasswordField = "PasswordField",
  MultiSelect = "MultiSelect",
  KeyValuePairs = "KeyValuePairs",
  OrganizationDropdown = "OrganizationDropdown",
  SiteDropdown = "SiteDropdown",
  SystemDropdown = "SystemDropdown",
  EdgeDeviceDropdown = "EdgeDeviceDropdown",
  CheckBox = "CheckBox",
  IncadaTenantIdDropdown = "IncadaTenantIdDropdown",
  IncadaTenantSlugDropdown = "IncadaTenantSlugDropdown",
  IncadaRegionDropdown = "IncadaRegionDropdown",
  IncadaLocationSlugDropdown = "IncadaLocationSlugDropdown"
}

export enum InputMode {
  Add = "Add",
  Edit = "Edit",
  View = "View",
}

export enum ClientSideValidator {
  RequiredFieldValidation = "RequiredFieldValidation",
  IPAddressValidation = "IPAddressValidation"
}

export class FeatureSelectedEventArgs {
  featureMetadata: DeploymentTypeMetadata;
  selected: boolean;
  isUserInput?: boolean;
}

export enum SystemType {
  ATP = 1,
  PASS = 2,
  MAX = 3,
  MINI = 4,
  SA_CAL = 5,
  ATP_CAPS = 6,
  PARATA_COMPLETE_CONNECT = 8
}